import { useLocalStorageState } from 'ahooks';

import { useIsHydrating } from '@zg-rentals/react-hooks';

export const MESSAGES_MOVED_CALLOUT_DISMISSED_KEY = 'zrm.messagesMovedCalloutDismissed';

export function useMessagesMovedCallout(enabled: boolean): { open: boolean; dismiss: () => void } {
  const isHydrating = useIsHydrating();
  const [dismissed, setDismissed] = useLocalStorageState<boolean>(MESSAGES_MOVED_CALLOUT_DISMISSED_KEY, {
    defaultValue: false,
  });

  return {
    open: enabled && !isHydrating && !dismissed,
    dismiss: () => setDismissed(true),
  };
}
